import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { SectionHeading } from "components/misc/Headings.js";
import { Container } from "components/misc/Layouts.js";

const Heading = tw(SectionHeading)`text-center`;
const LogosContainer = tw.div`mt-8 flex gap-3 flex-wrap justify-center mb-8`;
const HighlightedText = tw.span`bg-primary-100 text-gray-100 px-4 transform -skew-x-12 inline-block`;
const LogoImage = styled.img`
  ${tw`w-48 h-20 mx-4 mb-6`}
`;

export default () => {
  const logos = [
    "../part1.png",
    "../part2.png",
    "../part3.png",
  ];

  return (
    <Container>
      <Heading>Nossos <HighlightedText>Apoiadores</HighlightedText></Heading>
      <LogosContainer>
        {logos.map((logo, index) => (
          <LogoImage style={{width: "190px", height: "100px"}} key={index} src={logo} alt={`Apoiador ${index + 1}`} />
        ))}
      </LogosContainer>
    </Container>

  );
}; 